export const feedbackI18NPl = {
    feedback: `Twoje uwagi`,
    send: `Wyślij`,
};
